import { defineStore } from "pinia";
import { reactive, toRefs } from "vue";

import type { BoardType } from "@/model/baseTypes";

export interface Settings {
  isBacklogAlmStickyDeletable: boolean;
  isTeamAlmStickyDeletable: boolean;
  isPriorityEditable: boolean;
  confirmDelete: boolean;
  moveBetweenTeams: boolean;
  mirrorAssignedBacklogStickiesToTeamBoard: boolean;
  iterationLoadWarn: number | null;
  iterationLoadCritical: number | null;
  showDevLinks: boolean;
}

export const useServerSettingsStore = defineStore("serverSettings", () => {
  const settings = reactive<Settings>({
    isBacklogAlmStickyDeletable: true,
    isTeamAlmStickyDeletable: true,
    isPriorityEditable: true,
    confirmDelete: true,
    moveBetweenTeams: true,
    mirrorAssignedBacklogStickiesToTeamBoard: true,
    iterationLoadWarn: null,
    iterationLoadCritical: null,
    showDevLinks: false,
  });

  function isStickyDeletable(boardType: BoardType) {
    switch (boardType) {
      case "backlog":
        return settings.isBacklogAlmStickyDeletable;
      case "team":
        return settings.isTeamAlmStickyDeletable;
      default:
        return true;
    }
  }

  return { ...toRefs(settings), isStickyDeletable };
});
